<template>
    <div id="header__nav" class="header__nav">
        <div class="container">
            <div class="header__nav_items">
                <div class="columns is-variable">
                    <div class="column">
                        <ul class="header__nav_items_list">
                            <li v-for="item in itemsOutput" :key="item.id">
                                <component-button
                                    :class="[
                                        'header__nav_items_list_item',
                                        `header__nav_items_list_item--${item.name}`
                                    ]"
                                    :to="{ name: item.routeName }"
                                    :theme="'nav'"
                                    :size="'medium'"
                                    :name="`header-nav-items-list-item-${item.name}`"
                                >{{ toCapitalize(item.name) }}
                                </component-button>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { User } from '@/User'
import ComponentButton from '@/components/default/shared/ComponentButton'

export default {
  name: 'header-nav',
  components: { ComponentButton },
  data () {
    let user = new User()
    return {
      user: user,
      items: [
        // home
        {
          name: this.$t('header.nav.calendar'),
          routeName: 'ebs-calendar',
          visible: () => (
            (
              this.user.isEventCoordinator() ||
          this.user.isInfrastructureManager() ||
          this.user.isTrainer() ||
          this.user.isLearner()
            ) &&
          this.user.hasAnyCustomerService(['EBS']) &&
          this.$route.meta.allowedFor === 'home'
          )
        },
        // catalogue
        {
          name: this.$t('header.nav.courses'),
          routeName: 'ebs-course-list',
          visible: () => (
            (
              (
                (
                  this.user.isCourseCreator() ||
          this.user.isCourseLicenceManager() ||
          this.user.isLearner() ||
          this.user.isLearningExperienceAdministrator()
                ) &&
          this.user.hasAnyCustomerService(['CCS'])
              ) ||
          (
            (
              this.user.isLearner() ||
          this.user.isLearningExperienceAdministrator()
            ) &&
          this.user.hasAnyCustomerService(['LMS'])
          )
            ) &&
          this.$route.meta.allowedFor === 'catalogue'
          )
        },
        {
          name: 'Requests',
          routeName: 'ebs-requests-list',
          visible: () => (
            (
              this.user.isLearningExperienceAdministrator() ||
            this.user.isOrgUnitManager()
            ) &&
          this.$route.meta.allowedFor === 'catalogue'
          )
        },
        {
          name: this.$t('header.nav.events'),
          routeName: 'ebs-event-list',
          visible: () => (
            (
              this.user.isEventCoordinator() ||
          this.user.isInfrastructureManager() ||
          this.user.isTrainer() ||
          (
            this.user.isLearner() &&
          !this.$store.getters.getDefaultCustomerOptionsHideEventsCatalogue
          )
            ) &&
          this.user.hasAnyCustomerService(['EBS']) &&
          this.$route.meta.allowedFor === 'catalogue'
          )
        },
        {
          routeName: 'ebs-module-list',
          name: 'Modules',
          visible: () => (
            this.user.isCourseCreator() &&
          this.user.hasAnyCustomerService(['CCS']) &&
          this.$route.meta.allowedFor === 'catalogue'
          )
        },
        {
          routeName: 'ebs-licence-list',
          name: 'Licences',
          visible: () => (
            (
              this.user.isCourseLicenceManager() ||
          this.user.isCourseCreator()
            ) &&
          this.user.hasAnyCustomerService(['CCS']) &&
          this.$route.meta.allowedFor === 'catalogue'
          )
        },
        // users
        {
          name: this.$t('header.topAccountNav.menu.users'),
          routeName: 'lms-superadmin-user-list',
          visible: () => (
            (
              (
                this.user.isSuperadmin() ||
          this.user.isUserAdministrator() ||
          this.user.isMasterAdministrator() ||
          this.user.isOrgUnitManager()
              ) &&
          this.user.isTokenFromNewLms()
            ) &&
          this.$route.meta.allowedFor === 'users'
          )
        },
        {
          name: 'Organisation units',
          routeName: 'lms-superadmin-org-units-edit',
          visible: () => (
            this.user.isSuperadmin() ||
          this.user.isMasterAdministrator() ||
          this.user.isUserAdministrator()
          ) &&
          this.user.isTokenFromNewLms() &&
          this.user.hasSelectedProfile() &&
          this.$route.meta.allowedFor === 'users'
        },
        {
          name: 'Groups',
          routeName: 'lms-superadmin-groups-edit',
          visible: () => (
            this.user.isSuperadmin() ||
          this.user.isMasterAdministrator() ||
          this.user.isUserAdministrator()
          ) &&
          this.user.isTokenFromNewLms() &&
          this.user.hasSelectedProfile() &&
          this.$route.meta.allowedFor === 'users'
        },
        {
          name: this.$t('header.nav.trainers'),
          routeName: 'ebs-trainer-list',
          visible: () => (
            this.user.isEventCoordinator() &&
          this.user.hasAnyCustomerService(['EBS']) &&
          this.$route.meta.allowedFor === 'users'
          )
        },
        {
          name: 'Auto-enrolments',
          routeName: 'ebs-autoenrolments-list',
          visible: () => (
            this.user.isLearningExperienceAdministrator() &&
          this.user.hasAnyCustomerService(['LMS']) &&
          this.$route.meta.allowedFor === 'users'
          )
        },
        {
          name: 'Workflows',
          routeName: 'ebs-workflows-list',
          visible: () => (
            this.user.isLearningExperienceAdministrator() &&
          this.user.hasAnyCustomerService(['LMS']) &&
          this.$route.meta.allowedFor === 'users'
          )
        },
        // reports
        {
          name: 'Dashboard',
          routeName: 'ebs-report-dashboard-show',
          visible: () => (
            (
              this.user.isTokenFromNewLms() &&
          this.user.hasAnyCustomerService(['LMS', 'EBS']) &&
          (
            this.user.isLearningExperienceAdministrator() ||
          this.user.isMasterAdministrator() ||
          this.user.isOrgUnitManager() ||
          this.user.isSuperadmin()
          )
            ) &&
          this.$route.meta.allowedFor === 'report'
          )
        },
        {
          name: 'Reports',
          routeName: 'ebs-report-list',
          visible: () => (
            (
              (
                this.user.isTokenFromOldLms() &&
          this.user.isEventCoordinator()
              ) ||
          (
            this.user.isTokenFromNewLms() &&
          this.user.hasAnyCustomerService(['LMS']) &&
          (
            this.user.isSuperadmin() ||
          this.user.isMasterAdministrator() ||
          this.user.isLearningExperienceAdministrator()
          )
          ) ||
          (
            this.user.isTokenFromNewLms() &&
          this.user.hasAnyCustomerService(['EBS']) &&
          (
            this.user.isSuperadmin() ||
          this.user.isMasterAdministrator() ||
          this.user.isEventCoordinator()
          )
          )
            ) &&
          this.$route.meta.allowedFor === 'report'
          )
        },
        // admin
        {
          name: this.$t('header.nav.venues'),
          routeName: 'ebs-venue-list',
          visible: () => (
            (
              this.user.isEventCoordinator() ||
          this.user.isInfrastructureManager()
            ) &&
          this.user.hasAnyCustomerService(['EBS']) &&
          this.$route.meta.allowedFor === 'admin'
          )
        },
        {
          name: this.$t('header.topAccountNav.menu.mediaLibrary'),
          routeName: 'media-library-list',
          visible: () => (
            (
              this.user.isUserAdministrator() ||
          this.user.isEventCoordinator() ||
          this.user.isLearningExperienceAdministrator() ||
          this.user.isInfrastructureManager() ||
          this.user.isTrainer() ||
          (this.user.isMasterAdministrator() && this.user.hasSelectedProfile())
            ) &&
          this.user.hasSelectedProfile() &&
          this.$route.meta.allowedFor === 'admin'
          )
        },
        {
          name: this.$t('header.nav.notifications'),
          routeName: 'lms-notification-list',
          visible: () => (
            (
              this.user.isDigitalWorkbookAdmin() ||
          this.user.isEventCoordinator() ||
          this.user.isUserAdministrator() ||
          this.user.isLearningExperienceAdministrator() ||
          (this.user.isMasterAdministrator() && this.user.hasSelectedProfile())
            ) &&
          this.user.hasAnyCustomerService(['EBS', 'LMS', 'DW']) &&
          this.$route.meta.allowedFor === 'admin'
          )
        },
        {
          name: this.$t('header.topAccountNav.menu.customers'),
          routeName: 'lms-superadmin-customer-list',
          visible: () => (
            (this.user.isSuperadmin()) &&
          this.$route.meta.allowedFor === 'admin'
          )
        },
        {
          name: this.$t('header.topAccountNav.menu.workspaces'),
          routeName: 'lms-superadmin-workspace-list',
          visible: () => (
            (
              this.user.isSuperadmin() ||
          this.user.isMasterAdministrator()
            ) &&
          this.$route.meta.allowedFor === 'admin'
          )
        },
        {
          name: 'Archived',
          routeName: 'lms-superadmin-archived-list',
          visible: () => (
            (
              this.user.isSuperadmin()
            ) &&
          this.$route.meta.allowedFor === 'admin'
          )
        },
        // {
        //   name: 'Audit log',
        //   routeName: 'lms-superadmin-audit-log-list',
        //   visible: () => (
        //   (
        //   this.user.isSuperadmin() ||
        //   this.user.isMasterAdministrator()
        //   ) &&
        //   this.$route.meta.allowedFor === 'admin'
        //   )
        // },
        {
          name: this.$t('header.nav.achievements'),
          routeName: 'lms-user-achievement-list',
          visible: () => (
            false &&
          this.user.isLearningExperienceAdministrator() &&
          this.user.hasAnyCustomerService(['EBS', 'LMS']) &&
          this.$route.meta.allowedFor === 'admin'
          )
        },
        // my learning
        {
          name: 'My courses',
          routeName: 'dashboard-courses',
          visible: () => (
            this.user.isLearner() &&
          this.user.isTokenFromNewLms() &&
          this.user.hasAnyCustomerService(['LMS']) &&
          this.$route.meta.allowedFor === 'my-learning'
          )
        },
        {
          name: 'My events',
          routeName: 'dashboard-learner',
          visible: () => (
            this.user.isLearner() &&
          this.user.isTokenFromNewLms() &&
          this.user.hasAnyCustomerService(['EBS']) &&
          this.$route.meta.allowedFor === 'my-learning'
          )
        },
        {
          name: 'My completions',
          routeName: 'dashboard-completions',
          visible: () => (
            this.user.isLearner() &&
          this.user.isTokenFromNewLms() &&
          this.user.hasAnyCustomerService(['EBS']) &&
          this.$route.meta.allowedFor === 'my-learning'
          )
        }
      ]
    }
  },
  computed: {
    itemsOutput () {
      return this.items.filter(item => {
        return item.visible()
      })
    },
    secondStageToken () {
      return this.$store.getters.getAuthUserSecondStageTokenData
    }
  },
  watch: {
    secondStageToken () {
      this.user = new User()
    }
  },
  methods: {
    handleNavFadeEffect () {
      const navEl = this.$el.getElementsByClassName('header__nav_items')[0]
      const navElWidth = navEl.offsetWidth
      const navListEl = this.$el.getElementsByClassName('header__nav_items_list')[0]
      const navListElScrollLeft = navListEl.scrollLeft
      const listItems = navEl.getElementsByTagName('li')
      const listItemPadding = 20
      let listItemsWidth = 0

      for (let item of listItems) {
        listItemsWidth += item.offsetWidth
      }

      if ((navElWidth + navListElScrollLeft) <= (listItemsWidth - listItemPadding)) {
        navEl.classList.add('header__nav_items--fadeeffect')
      } else {
        navEl.classList.remove('header__nav_items--fadeeffect')
      }
    }
  },
  updated () {
    this.handleNavFadeEffect()
  },
  mounted () {
    this.handleNavFadeEffect()

    const navEl = this.$el.getElementsByClassName('header__nav_items_list')[0]
    navEl.addEventListener('scroll', this.handleNavFadeEffect)
  },
  beforeDestroy () {
    const navEl = this.$el.getElementsByClassName('header__nav_items_list')[0]
    navEl.removeEventListener('scroll', this.handleNavFadeEffect)
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/layout/header/headernav";
</style>
